import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoginRegisterPage from './index';

/**
 * Wrapper component for LoginRegister that handles already authenticated users
 */
const LoginRegisterWrapper = () => {
  const { user, userProfile, loading } = useAuth();

  // If still loading, show a minimal loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-text-secondary">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If user is already authenticated and has a profile, redirect to their dashboard
  if (user && userProfile) {
    const getDashboardPath = (role) => {
      switch (role) {
        case 'admin':
          return '/admin-moderation';
        case 'moderator':
          return '/admin-moderation?tab=reports';
        case 'employer':
          return '/employer-dashboard';
        case 'va':
        default:
          return '/va-dashboard';
      }
    };

    const dashboardPath = getDashboardPath(userProfile.role);
    return <Navigate to={dashboardPath} replace />;
  }

  // If user is authenticated but doesn't have a profile (edge case), let them through
  // The LoginRegister component will handle this scenario
  return <LoginRegisterPage />;
};

export default LoginRegisterWrapper;


